<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2" color="primary">mdi-sim</v-icon>
      {{ t.dashboard?.sim_search || 'SIM Search' }}
    </v-card-title>
    <v-card-text>
      <v-row align="center">
        <v-col cols="12" md="10">
          <v-text-field
            v-model="searchTerm"
            :label="t.dashboard?.sim_search_label || 'Search by IMSI, Serial, MSISDN, Equipment Serial, NUI'"
            :hint="isMultilevelReseller ? (t.dashboard?.minimum_3_chars || 'Minimum 3 characters') : ''"
            persistent-hint
            prepend-inner-icon="mdi-magnify"
            clearable
            density="compact"
            variant="outlined"
            @keyup.enter="search"
            @click="$event.target.select()"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-btn color="primary" block @click="search" :disabled="!canSearch">
            <v-icon class="mr-1">mdi-magnify</v-icon>
            {{ t.common?.search || 'Search' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import store from '@/store'

export default {
  name: 'SimSearchSection',
  props: {
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      searchTerm: ''
    }
  },
  computed: {
    t() { return tRef.value },
    isMultilevelReseller() {
      const ct = store.getters.getUser?.client_type_name?.toLowerCase() || ''
      return ct === 'multilevel'
    },
    canSearch() {
      if (!this.isMultilevelReseller) return this.searchTerm?.trim().length >= 1
      return this.searchTerm?.trim().length >= 3
    }
  },
  methods: {
    search() {
      if (this.canSearch) {
        this.$router.push({ name: 'sims', query: { search: this.searchTerm.trim() } })
      }
    }
  }
}
</script>
